<template>
  <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4 border-r border-gray-200">
    <!-- Логотип -->
    <div class="flex h-16 shrink-0 items-center">
      <h1 class="text-xl font-bold text-gradient">
        Dashboard System
      </h1>
    </div>

    <!-- Навигация -->
    <nav class="flex flex-1 flex-col">
      <ul role="list" class="flex flex-1 flex-col gap-y-7">
        <!-- Основная навигация -->
        <li>
          <ul role="list" class="-mx-2 space-y-1">
            <li v-for="item in navigation" :key="item.name">
              <router-link
                :to="item.to"
                :class="[
                  $route.path === item.to
                    ? 'nav-link-active'
                    : 'nav-link-inactive'
                ]"
              >
                <component :is="item.icon" class="h-5 w-5 shrink-0" />
                {{ item.name }}
              </router-link>
            </li>
          </ul>
        </li>

        <!-- Отчеты -->
        <li>
          <div class="text-xs font-semibold leading-6 text-gray-400 uppercase tracking-wide">
            Отчеты
          </div>
          <ul role="list" class="-mx-2 mt-2 space-y-1">
            <li v-for="report in reports" :key="report.name">
              <router-link
                :to="report.to"
                :class="[
                  activeReportTo === report.to
                    ? 'nav-link-active'
                    : 'nav-link-inactive'
                ]"
              >
                <component :is="report.icon" class="h-5 w-5 shrink-0" />
                {{ report.name }}
                <span v-if="report.badge" class="ml-auto">
                  <span class="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800">
                    {{ report.badge }}
                  </span>
                </span>
              </router-link>
            </li>
          </ul>
        </li>

<!--        &lt;!&ndash; Данные &ndash;&gt;-->
<!--        <li>-->
<!--          <div class="text-xs font-semibold leading-6 text-gray-400 uppercase tracking-wide">-->
<!--            Данные-->
<!--          </div>-->
<!--          <ul role="list" class="-mx-2 mt-2 space-y-1">-->
<!--            <li v-for="collection in collections" :key="collection.name">-->
<!--              <router-link-->
<!--                :to="`/data/${collection.name}`"-->
<!--                :class="[-->
<!--                  $route.params.collection === collection.name-->
<!--                    ? 'nav-link-active'-->
<!--                    : 'nav-link-inactive'-->
<!--                ]"-->
<!--              >-->
<!--                <component :is="getCollectionIcon(collection.name)" class="h-5 w-5 shrink-0" />-->
<!--                {{ getCollectionTitle(collection.name) }}-->
<!--                <span class="ml-auto text-xs text-gray-400">-->
<!--                  {{ formatNumber(collection.count) }}-->
<!--                </span>-->
<!--              </router-link>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </li>-->

        <!-- Инструменты -->
<!--        <li class="mt-auto">-->
<!--          <div class="text-xs font-semibold leading-6 text-gray-400 uppercase tracking-wide">-->
<!--            Инструменты-->
<!--          </div>-->
<!--          <ul role="list" class="-mx-2 mt-2 space-y-1">-->
<!--            <li v-for="tool in tools" :key="tool.name">-->
<!--              <router-link-->
<!--                :to="tool.to"-->
<!--                :class="[-->
<!--                  $route.path === tool.to-->
<!--                    ? 'nav-link-active'-->
<!--                    : 'nav-link-inactive'-->
<!--                ]"-->
<!--              >-->
<!--                <component :is="tool.icon" class="h-5 w-5 shrink-0" />-->
<!--                {{ tool.name }}-->
<!--              </router-link>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </li>-->
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import {
  HomeIcon,
  ChartBarIcon,
  UserGroupIcon,
  PhoneIcon,
  BuildingOfficeIcon,
  CurrencyDollarIcon,
  ClipboardDocumentListIcon,
  UsersIcon,
  BuildingOffice2Icon,
  Cog6ToothIcon,
  DocumentArrowDownIcon,
  DocumentChartBarIcon,
  PresentationChartLineIcon,
  AcademicCapIcon,
  TableCellsIcon,
  EnvelopeIcon,
  CalendarDaysIcon,
  CalendarIcon
} from '@heroicons/vue/24/outline'
import { useDataStore } from '@/stores/data'

const dataStore = useDataStore()
const route = useRoute()

// Состояние
const collections = ref([])

// Основная навигация
const navigation = [
  { name: 'Главная', to: '/dashboard', icon: HomeIcon },
  // { name: 'Мои дэшборды', to: '/dashboards', icon: ChartBarIcon },
]

// === НОВЫЙ РАЗДЕЛ: ОТЧЕТЫ ===
const reports = [
  {
    name: 'Отчет по лидам',
    to: '/reports/leads',
    icon: DocumentChartBarIcon,
    
  },
  {
    name: 'Динамика изменений',
    to: '/reports/leads/comparison',
    icon: PresentationChartLineIcon,
    
  },
  {
    name: 'Изменения лидов',
    to: '/reports/leads/changes',
    icon: ClipboardDocumentListIcon,
    
  },
  {
    name: 'Изменения лидов по менеджерам',
    to: '/reports/leads/changes/form',
    icon: UsersIcon,
  },
  {
    name: 'Еженедельный отчёт',
    to: '/reports/leads/weekly',
    icon: CalendarDaysIcon,
  },
  {
    name: 'Ежемесячный отчёт',
    to: '/reports/leads/monthly',
    icon: CalendarIcon,
  },
  {
    name: 'Тренинг-центр',
    to: '/reports/training-center',
    icon: AcademicCapIcon,
  },
  {
    name: 'Рассылки',
    to: '/reports/schedules',
    icon: EnvelopeIcon,
  },
  // Можно добавить другие отчеты в будущем:
  // {
  //   name: 'Отчет по сделкам',
  //   to: '/reports/deals',
  //   icon: PresentationChartLineIcon
  // },
  // {
  //   name: 'Сводный отчет',
  //   to: '/reports/summary',
  //   icon: TableCellsIcon
  // },
]

// Подсвечиваем один пункт — с самым длинным совпавшим путём
// (иначе на /reports/leads/changes горели бы и «Отчет по лидам», и «Изменения лидов»)
const activeReportTo = computed(() => {
  const path = route.path
  return reports
    .map((report) => report.to)
    .filter((to) => path === to || path.startsWith(`${to}/`))
    .sort((a, b) => b.length - a.length)[0]
})

// Инструменты
const tools = [
  // { name: 'Настройки', to: '/settings', icon: Cog6ToothIcon },
  // { name: 'Экспорт', to: '/export', icon: DocumentArrowDownIcon },
]

// Методы
const getCollectionIcon = (collectionName) => {
  const icons = {
    leads: UserGroupIcon,
    deals: CurrencyDollarIcon,
    contacts: PhoneIcon,
    companies: BuildingOfficeIcon,
    tasks: ClipboardDocumentListIcon,
    users: UsersIcon,
    departments: BuildingOffice2Icon
  }
  return icons[collectionName] || ClipboardDocumentListIcon
}

const getCollectionTitle = (collectionName) => {
  const titles = {
    leads: 'Лиды',
    deals: 'Сделки',
    contacts: 'Контакты',
    companies: 'Компании',
    tasks: 'Задачи',
    users: 'Пользователи',
    departments: 'Отделы'
  }
  return titles[collectionName] || collectionName
}

const formatNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K'
  }
  return num.toString()
}

// Загрузка коллекций
const loadCollections = async () => {
  try {
    const data = await dataStore.getCollections()
    collections.value = data
  } catch (error) {
    console.error('Ошибка загрузки коллекций в сайдбаре:', error)
  }
}

onMounted(() => {
  loadCollections()
})
</script>

<style scoped>
.nav-link-active {
  @apply bg-blue-100 text-blue-700;
}

.nav-link-inactive {
  @apply text-gray-600 hover:bg-gray-100 hover:text-gray-900;
}

.nav-link-active,
.nav-link-inactive {
  @apply flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors;
}

.text-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
</style>